<template>
  <v-btn small outline @click="export_csv()">CSV</v-btn>
</template>

<script>
export default {
  props: ["attr_names", "column_names", "filename", "data", "downloadable"],
  data() {
    return {};
  },
  computed: {},
  created: function () {},
  methods: {
    resolve(path, obj = self, separator = ".") {
      let properties = Array.isArray(path) ? path : path.split(separator);
      return properties.reduce((prev, curr) => prev && prev[curr], obj);
    },
    download(filename, text) {
      var element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(text)
      );
      element.setAttribute("download", filename);
      element.style.display = "none";
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    },
    export_csv: async function () {
      let row = "";
      let csvFile = "";

      this.column_names.forEach((attr) => {
        row += attr + ";";
      });
			
      csvFile += row.slice(0, -1) + "\r\n";
      let data = [];
      // se for function, deve ser promise
      if (typeof this.data === 'function') {
        data = await this.data()
      } else {
        data = this.data;
      }

      data.forEach((obj) => {
        row = "";

        this.attr_names.forEach((attr) => {
          let attr_value = this.resolve(attr, obj);

          if (attr_value != undefined) {
            row += attr_value.replace(";", ":");
          }

          row += ";";
        });

        csvFile += row.slice(0, -1) + "\r\n";
      });

      this.download(this.filename + ".csv", csvFile);
    },
  },
  watch: {},
};
</script>
